import reactStringReplace from 'react-string-replace';

import { Alert as ConstAlert } from '@zillow/constellation';
import { Anchor, Text } from '@zillow/constellation-10';

import { useSelector } from '../../../../selectors/useSelector';

import { LISTING_SUMMARY_DISPLAY_STATUS } from '../../../../constants/ListingSummaryConstants';

const Alert = () => {
  const {
    currentProperty: {
      syndication: {
        universal: { message = '', replaceUrl = '', replaceText = '' } = {},
        overview: { displayStatus = '' } = {},
      } = {},
    },
  } = useSelector((state) => state.properties);

  const appearance = displayStatus === LISTING_SUMMARY_DISPLAY_STATUS.DECLINED ? 'error' : 'warning';

  const renderedMessage = reactStringReplace(message, replaceText, () => (
    <Text>
      <Anchor
        href={replaceUrl}
        target="_blank"
        css={{ _hover: { textDecoration: 'none' }, _visited: { color: 'text.accent.brand.hero' } }}
      >
        {replaceText}
      </Anchor>
    </Text>
  ));

  if (message && replaceText) {
    return <ConstAlert className="Alert" appearance={appearance} body={renderedMessage} />;
  }

  return null;
};

export default Alert;
